import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b302577"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "workbench-wrapper ver-tabs" }
const _hoisted_2 = { class: "workbench-title" }
const _hoisted_3 = {
  key: 0,
  class: "workbench-item-list"
}
const _hoisted_4 = ["onClick", "onKeyup"]
const _hoisted_5 = { class: "workbench-item_icon" }
const _hoisted_6 = { class: "workbench-item_name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pg_icon = _resolveComponent("pg-icon")!
  const _component_Empty = _resolveComponent("Empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.t('workbench')), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.menuListWithoutHistory, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "workbench-list",
        key: i
      }, [
        (item.children && item.children.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (item2, j) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "workbench-item-wrapper",
                  key: j
                }, [
                  _createElementVNode("div", {
                    class: "workbench-item",
                    onClick: ($event: any) => (_ctx.handleClickUrl(item2)),
                    onKeyup: ($event: any) => (_ctx.handleClickUrl(item2))
                  }, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_pg_icon, {
                        name: item2.icon || item2.iconActive,
                        size: 28
                      }, null, 8, ["name"])
                    ]),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(item2.name), 1)
                  ], 40, _hoisted_4)
                ]))
              }), 128))
            ]))
          : (_ctx.state.inited)
            ? (_openBlock(), _createBlock(_component_Empty, {
                key: 1,
                class: "workbench-menu-list-empty",
                desc: _ctx.t('workbenchNoRecentdata'),
                image: "cup"
              }, null, 8, ["desc"]))
            : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}